import { BaseService } from './base-service'
import { Observable } from 'rxjs'
import { AccountAPIConstant } from '@/api/constant/account'
import {
    AccountPageRequestModel,
    AccountParams,
    OpenAccountParams,
    RechargeParams,
    AccountPageRecord,
    BankItem,
    StateParam,
    ReleaseParams,
    RepaymentParams
} from '@/api/model/account'
import { Page } from '@/api/model/base'

export class AccountService extends BaseService {
    protected accountConstant: AccountAPIConstant
    constructor() {
        super()
        this.accountConstant = new AccountAPIConstant()
    }

    accountPage(data: AccountPageRequestModel): Observable<Page<AccountPageRecord>> {
        return this.request(this.accountConstant.accountPage(data))
    }

    openAccount(data: OpenAccountParams): Observable<AccountParams> {
        return this.request(this.accountConstant.openAccount(data))
    }

    getBankList(): Observable<Array<BankItem>> {
        return this.request(this.accountConstant.getBankList())
    }

    recharge(data: RechargeParams): Observable<AccountParams> {
        return this.request(this.accountConstant.recharge(data))
    }

    updateState(data: StateParam): Observable<AccountParams> {
        return this.request(this.accountConstant.updateState(data))
    }

    getReleaseList(data: ReleaseParams): Observable<AccountParams> {
        return this.request(this.accountConstant.getReleaseList(data))
    }
    getRepaymentList(data: RepaymentParams): Observable<AccountParams> {
        return this.request(this.accountConstant.getRepaymentList(data))
    }
    getDailyBusinessList(data: RepaymentParams): Observable<AccountParams> {
        return this.request(this.accountConstant.getDailyBusinessList(data))
    }
}
